import { is } from 'ramda';

const isNumber = is(Number);
export const isCoordsCorrect = (coords) => coords && isNumber(coords.longitude) && isNumber(coords.latitude);
